import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import { ButtonGroup, IconButton, Stack, TextField } from '@mui/material';
import { Image, NavigateBefore } from '@mui/icons-material';
import Service from '../../util/Service';


const maxWidth = 750;
const maxHeight = 300;

export default function ImagemDialog(props) {
    const { anexo, open, setOpen, action } = props;
    const [arquivoModificado, setArquivoModificado] = React.useState(false);
    const [tipo, setTipo] = React.useState(anexo.tipo);
    const [nome, setNome] = React.useState(anexo.nome);
    const [descricao, setDescricao] = React.useState(anexo.desc||'');
    const [erroTipo, setErroTipo] = React.useState('');

    const [direction, setDirection] = React.useState('row');

    React.useEffect(() => {
        if (anexo) {
            console.log(anexo);
            setNome(anexo.nome||'');
            setTipo(anexo.tipo||'');
            setDescricao(anexo.desc?anexo.desc:'');
            // const preview = document.getElementById('file-preview');
            // preview.src = `/api/getAnexoById/${anexo.idArquivo}`;
        }
    }, [anexo])
    const handleClose = (r) => {
        setOpen(false);
    }

    const upload = () => {
        console.log( "upload" );
        let input = document.getElementById("fileImgDlg");
        const file = input.files;
        if (file) {
            const fileReader = new FileReader();
            const preview = document.getElementById('file-preview');
            fileReader.onload = event => {
                preview.setAttribute('src', event.target.result);
            }            
            console.log(file[0]);
            if( (!nome || nome.length ===0) ) setNome(file[0].name);
            setArquivoModificado(true);
            fileReader.readAsDataURL(file[0]);
        }
    }
    function handleOnLoad(e) {
        const img = e.target;
        let originalWidth = img.naturalWidth;
        let originalHeight = img.naturalHeight;
        let aspectRatio = originalWidth / originalHeight;
        console.log(aspectRatio, originalWidth, originalHeight);
        setDirection('row');
        if (originalWidth > maxWidth) {
            let newWidth = maxWidth;
            let newHeight = newWidth / aspectRatio;
            img.width = newWidth;
            img.height = newHeight;
            setDirection('column');
        } else if (originalHeight > maxHeight) {
            let newHeight = maxHeight;
            let newWidth = newHeight * aspectRatio;
            img.width = newWidth;
            img.height = newHeight;
        }
    }
    function handleSalvarAnexo(){
        console.log(arquivoModificado)
        if (!tipo || tipo.length < 2) {
            setErroTipo('Tipo é campo obrigatório!');
            return;
        }
        const dado = {...anexo};
        dado.nome = nome;
        dado.tipo = tipo;
        dado.desc = descricao;
        console.log(dado);
        
        Service.POST("/api/security/salvaAnexo", dado).then(r => {
            console.log(r);
            if( arquivoModificado){
                uploadArquivo(r)
            }else{
                handleClose();
            }
        }).catch(e => {
            console.log("erro--->", e)
            alert(e);
        })   
    }
    function uploadArquivo(ret) {
        let input = document.getElementById("fileImgDlg");
        const file = input.files;
        let dados = new FormData();
        dados.append('file', file[0]);

        Service.UPLOAD("/api/security/anexar/" + ret.id, dados).then(r => {
            console.log(r);
            // if (r.success) {             
                // createImg("/api/getAnexoById/" + r.anexo.idArquivo)
                // setOpenUpload(false);
                // setIsShowGaleria(false);
                handleClose();
            // } else {
            //     alert(r.msg)
            // }

        }).catch(e => {
            console.log("erro--->", e)
            alert(e);
        })
    }
    return (
        <Dialog
            fullWidth
            maxWidth={direction==='row'?"md":'lg'}
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>{"Edição anexo "+anexo.nome}</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent sx={{ minHeight: '300px' }}>

                <Box
                    noValidate
                    component="form"
                    sx={{
                        // display: 'flex',
                        // flexDirection: 'column',
                        m: 'auto',
                        marginTop: 2
                    }}
                >
                    <Stack direction={direction} spacing={2}>
                        <Stack spacing={2} sx={{ m: 1, minWidth: 150 }}>
                            <TextField label="Nome" variant="outlined" value={nome} onChange={(e) => setNome(e.target.value)} />
                            <TextField autoFocus
                                placeholder='Tipifique para faciliar futuras pesquisas'
                                label="Tipo" variant="outlined" value={tipo} onChange={(e) => { tipo(e.target.value); setErroTipo(''); }}
                                error={erroTipo.length > 1}
                                helperText={erroTipo}
                            />
                            <TextField label="Descrição" variant="outlined" multiline rows={4} value={descricao} onChange={(e) => setDescricao(e.target.value)} />

                        </Stack>
                        <img
                            onLoad={handleOnLoad}
                            src={`/api/getAnexoById/${anexo.idArquivo}`}
                            alt="Preview Uploaded Image"
                            id="file-preview"
                        />

                    </Stack>
                </Box>
            </DialogContent>

            <DialogActions>
                <ButtonGroup variant="text" aria-label="Basic button group">
                    <Button
                        onClick={() => setOpen(false)}
                        startIcon={<NavigateBefore />}
                    >
                        Voltar
                    </Button>
                    <Button
                        onClick={() => {
                            const file = document.getElementById("fileImgDlg");
                            file.click();
                        }}
                        startIcon={<Image />}
                    >
                        Trocar imagem
                    </Button>
                    <Button
                    onClick={handleSalvarAnexo}
                    >Salvar</Button>
                </ButtonGroup>
            </DialogActions>
            <input type="file" id="fileImgDlg" style={{ display: 'none' }} onChange={upload} />
        </Dialog>
    )

}